import { Component, OnInit } from '@angular/core';
import { RecorderStore } from '../../../stores/recorder.store';
import { ShareService } from '../../../services/share.service';
import { MessageService } from '../../../../shared/services/message.service';

@Component({
  selector: 'app-share-link',
  templateUrl: './share-link.component.html',
  styleUrls: ['./share-link.component.styl']
})
export class ShareLinkComponent implements OnInit {
  processing = false;

  constructor(
    private recorderStore: RecorderStore,
    private shareService: ShareService,
    private messageService: MessageService,
  ) {
  }

  ngOnInit() {
  }

  onButtonClick() {
    if (this.processing === true) {
      return;
    }

    this.processing = true;

    this.recorderStore.getCompiledRecord()
      .then(mp3Data => this.shareService.upload(mp3Data))
      .then(() => this.processing = false)
      .catch(() => this.messageService.showServerError());
  }
}



// WEBPACK FOOTER //
// ./src/app/rec/components/share/share-link/share-link.component.ts